function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Elektroodpady");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.684 18.421a1.078 1.078 0 0 0-1.526 0l-2.607 2.607-4.579-4.579 2.607-2.607a1.079 1.079 0 0 0-1.526-1.526l-2.607 2.607-1.527-1.522-4.65 4.65a6.374 6.374 0 0 0 0 9.014l.071.072-5.34 5.34 1.526 1.526 5.341-5.34.071.071a6.374 6.374 0 0 0 9.015 0l4.649-4.65-1.526-1.526 2.607-2.607a1.078 1.078 0 0 0 .001-1.53zm-7.258 8.78a4.216 4.216 0 0 1-5.962 0l-1.67-1.67a4.216 4.216 0 0 1 0-5.962l.835-.835 7.631 7.631zm1.6-1.6l-7.631-7.631 1.526-1.526 7.631 7.631z"
});

var SvgElectric = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgElectric, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/electric.b635371c.svg";
export { ForwardRef as ReactComponent };